import Card, { CardProps } from '@components/Card';
import { CardBase } from '@components/Card/useCard';
import React from 'react';

const CardGeneric = <T extends CardBase = CardBase, D extends React.ElementType = 'article'>(
  props: CardProps<T, D>
) => <Card {...props} padding="lg" />;

export default CardGeneric;
